
    import './styles.scoped.css';
    export default {
  "toggle-button": "awsui_toggle-button_16w0h_qg1c0_185",
  "close-button": "awsui_close-button_16w0h_qg1c0_220"
};
  